import type { Dictionary } from "./fr";

/** Arabic translations — typed against the French dictionary so no key can be missing. */
export const ar: Dictionary = {
  app: {
    name: "طراوة",
    tagline: "مشترياتك حتى باب منزلك",
  },
  nav: {
    home: "الرئيسية",
    categories: "الأصناف",
    orders: "الطلبات",
    cart: "السلة",
    account: "حسابي",
  },
  common: {
    loading: "جار التحميل…",
    retry: "إعادة المحاولة",
    back: "رجوع",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    continue: "متابعة",
    seeAll: "عرض الكل",
    close: "إغلاق",
    optional: "اختياري",
    language: "اللغة",
    unavailable: "غير متوفر",
    or: "أو",
    loadError: "تعذر تحميل هذه الصفحة.",
    notFound: "الصفحة غير موجودة.",
    goHome: "العودة إلى الرئيسية",
  },
  home: {
    searchPlaceholder: "ابحث عن منتج…",
    categories: "الأصناف",
    packs: "الباقات",
    seasonal: "منتجات الموسم",
    featured: "منتجات مميزة",
    popular: "الأكثر طلبا",
    hello: "مرحبا {name}",
    helloGuest: "مرحبا",
    deliveryTo: "التوصيل في {city}",
    deliveryHours: "التوصيل من {start} إلى {end}",
    deliveryOff: "التوصيل غير متاح حاليا.",
    codBadge: "الدفع عند الاستلام",
    minOrder: "الحد الأدنى {amount}",
    fee: "التوصيل {amount}",
    freeDelivery: "توصيل مجاني",
    empty: "لا توجد منتجات حاليا.",
    heroTitle: "الطراوة حتى لباب دارك",
    heroText: "خيرات السوق من الخضر والفواكه حتى للحوم، كتختارها براحتك وكنوصلوها حتى لعندك.",
  },
  search: {
    title: "بحث",
    results: "{count} نتيجة",
    noResults: "لا توجد منتجات مطابقة لـ «{q}».",
    hint: "اكتب اسم منتج.",
  },
  categories: {
    title: "الأصناف",
    products: "{count} منتجات",
    empty: "لا توجد منتجات في هذا الصنف.",
    notFound: "الصنف غير موجود.",
    all: "الكل",
    subcategories: "الأصناف الفرعية",
  },
  product: {
    weight: "اختر الوزن",
    addToCart: "أضف إلى السلة",
    add: "أضف",
    added: "تمت الإضافة إلى السلة",
    quantity: "الكمية",
    unavailable: "هذا المنتج غير متوفر حاليا.",
    description: "الوصف",
    inCart: "{count} في السلة",
    notFound: "المنتج غير موجود.",
    increase: "زيادة الكمية",
    decrease: "تقليل الكمية",
    similar: "منتجات مشابهة",
  },
  pack: {
    badge: "باقة",
    contents: "محتوى الباقة",
    items: "{count} منتجات",
    unavailable: "هذه الباقة غير متوفرة حاليا.",
    notFound: "الباقة غير موجودة.",
  },
  cart: {
    title: "السلة",
    empty: "سلتك فارغة",
    emptyHint: "أضف منتجات للبدء.",
    browse: "تصفح المنتجات",
    subtotal: "المجموع الفرعي",
    delivery: "التوصيل",
    discount: "التخفيض",
    total: "المجموع",
    coupon: "رمز التخفيض",
    couponPlaceholder: "أدخل الرمز",
    apply: "تطبيق",
    remove: "إزالة",
    couponApplied: "تم تطبيق الرمز {code}",
    checkout: "اطلب الآن",
    view: "عرض السلة",
    minOrderNotMet: "أضف {amount} للوصول إلى الحد الأدنى للطلب ({min}).",
    unavailableItems: "بعض المنتجات لم تعد متوفرة. قم بإزالتها للمتابعة.",
    each: "للوحدة",
    items: "{count} منتج",
    deliveryOff: "التوصيل غير متاح حاليا.",
    orderingClosed: "الطلبات مغلقة حاليا. نستقبل الطلبات من {start} إلى {end}.",
    closingSoon: "تغلق الطلبات على الساعة {end}. أكمل طلبك بسرعة.",
    graceCheckout: "الطلبات مغلقة، لكن مازال لديك بضع دقائق لإتمام هذا الطلب.",
    updating: "جار التحديث…",
  },
  checkout: {
    title: "إتمام الطلب",
    deliveryInfo: "معلومات التوصيل",
    name: "الاسم",
    phone: "الهاتف",
    address: "العنوان",
    gps: "موقع GPS",
    gpsSaved: "تم حفظ موقع GPS",
    noGps: "غير محدد",
    chooseAddress: "اختر عنوان التوصيل",
    addAddress: "أضف عنوانا جديدا",
    summary: "ملخص الطلب",
    payment: "الدفع",
    cod: "الدفع عند الاستلام",
    codHint: "تدفع نقدا لعامل التوصيل عند استلام طلبك.",
    notes: "ملاحظة لعامل التوصيل",
    notesPlaceholder: "مثال: اضغط على جرس الباب",
    confirm: "تأكيد الطلب",
    placing: "جار إرسال الطلب…",
    noAddress: "أضف عنوان التوصيل للمتابعة.",
    phoneRequired: "أضف رقم هاتفك وتحقق منه: يجب أن يتمكن عامل التوصيل من الاتصال بك.",
    phoneRequiredNoSms: "أضف رقم هاتفك: يجب أن يتمكن عامل التوصيل من الاتصال بك.",
    cartChanged: "تغيرت سلتك. تحقق منها قبل الطلب.",
    backToCart: "العودة إلى السلة",
    missingTitle: "تبقى تفصيلة صغيرة",
    missingText: "أكمل هذه المعلومات لإتمام طلبك. سلتك محفوظة.",
    readyTitle: "كل شيء جاهز",
    readyText: "تحقق من المجموع ثم أكد طلبك.",
    stepPhone: "رقم الهاتف",
    stepAddress: "عنوان التوصيل",
    stepDone: "تم",
    addressOutside: "هذا العنوان خارج منطقة التوصيل. اختر عنوانا آخر أو أضف عنوانا جديدا.",
    outsideArea: "خارج منطقة التوصيل",
  },
  success: {
    title: "شكرا! تم إرسال طلبك",
    subtitle: "تم استلام طلبك. رقم الطلب:",
    payOnDelivery: "المبلغ المطلوب عند الاستلام",
    track: "تتبع طلبي",
    continue: "متابعة التسوق",
    sendWhatsApp: "أرسل طلبي عبر واتساب",
    whatsAppHint: "إذا لم يُفتح واتساب، اضغط على هذا الزر ثم على إرسال.",
  },
  orders: {
    title: "طلباتي",
    current: "الطلبات الجارية",
    past: "الطلبات السابقة",
    empty: "ليس لديك أي طلب بعد.",
    order: "الطلب",
    date: "التاريخ",
    items: "المنتجات",
    total: "المجموع",
    paymentMethod: "طريقة الدفع",
    paymentStatus: "حالة الدفع",
    status: "حالة الطلب",
    deliveryAddress: "عنوان التوصيل",
    reorder: "أعد الطلب",
    reordered: "تمت إضافة المنتجات إلى السلة",
    reorderSkipped: "غير متوفرة: {names}",
    reorderNone: "لا يتوفر أي من هذه المنتجات حاليا.",
    tracking: "تتبع الطلب",
    notFound: "الطلب غير موجود.",
    couponUsed: "رمز التخفيض {code}",
    articles: "{count} منتج",
    notes: "ملاحظة",
    viewOnMap: "عرض على الخريطة",
  },
  orderStatus: {
    PENDING: "قيد الانتظار",
    CONFIRMED: "تم التأكيد",
    PREPARING: "قيد التحضير",
    OUT_FOR_DELIVERY: "في الطريق إليك",
    DELIVERED: "تم التوصيل",
    CANCELLED: "ملغى",
    DELIVERY_FAILED: "تعذر التوصيل",
  },
  orderStatusHint: {
    PENDING: "توصلنا بطلبك، وسيتم تأكيده قريبا.",
    CONFIRMED: "تم تأكيد طلبك.",
    PREPARING: "نقوم بتحضير منتجاتك.",
    OUT_FOR_DELIVERY: "عامل التوصيل في الطريق إليك.",
    DELIVERED: "تم توصيل طلبك. بالصحة والعافية!",
    CANCELLED: "تم إلغاء هذا الطلب.",
    DELIVERY_FAILED: "لم نتمكن من توصيل طلبك. سيتواصل معك فريقنا.",
  },
  paymentStatus: {
    PENDING: "في الانتظار",
    PAID: "مدفوع",
    FAILED: "لم يتم التحصيل",
    CANCELLED: "ملغى",
  },
  paymentMethod: {
    CASH_ON_DELIVERY: "الدفع عند الاستلام",
  },
  account: {
    noPhone: "لا يوجد رقم موثق",
    addPhoneTitle: "أضف رقم هاتفك",
    addPhoneText: "ضروري للتوصيل. ستتلقى رمز تحقق عبر رسالة SMS.",
    addPhoneTextNoSms: "ضروري للتوصيل.",
    phoneVerified: "تم التحقق من الرقم.",
    phoneSaved: "تم حفظ الرقم.",
    savePhone: "حفظ الرقم",
    changePhone: "تغيير الرقم",
    changePhoneTitle: "تغيير رقم الهاتف",
    changePhoneText: "يبقى رقمك الحالي محفوظا إلى أن يتم التحقق من الرقم الجديد عبر SMS.",
    changePhoneTextNoSms: "سيحل الرقم الجديد محل الرقم الحالي.",
    googleTitle: "تسجيل الدخول بواسطة Google",
    googleLinkedAs: "حساب Google المرتبط:",
    googleLinkText: "اربط حسابك على Google لتسجيل الدخول بنقرة واحدة.",
    linkGoogle: "ربط حسابي على Google",
    title: "حسابي",
    personal: "المعلومات الشخصية",
    fullName: "الاسم الكامل",
    phone: "الهاتف",
    addresses: "عناويني",
    addAddress: "أضف عنوانا جديدا",
    default: "افتراضي",
    logout: "تسجيل الخروج",
    saved: "تم حفظ التغييرات",
    noAddress: "لا يوجد عنوان محفوظ.",
    deleteAddressConfirm: "حذف هذا العنوان؟",
    orders: "طلباتي",
    instagram: "طراوة على إنستغرام",
    whatsapp: "راسل طراوة على واتساب",
    guestTitle: "مرحبا بك في طراوة",
    guestText: "سجل الدخول لتطلب وتتابع طلباتك.",
    gpsSaved: "تم حفظ GPS",
  },
  privacy: {
    title: "سياسة الخصوصية",
  },
  photoCredits: {
    title: "مصادر الصور",
    source: "المصدر:",
    author: "المؤلف:",
    license: "الترخيص:",
  },
  address: {
    newTitle: "عنوان جديد",
    editTitle: "تعديل العنوان",
    label: "اسم العنوان",
    labelPlaceholder: "المنزل، العمل…",
    line: "العنوان",
    linePlaceholder: "الشارع، الرقم، الحي، العمارة، الطابق…",
    city: "المدينة",
    instructions: "إرشادات لعامل التوصيل",
    instructionsPlaceholder: "معلم قريب، رمز الدخول…",
    manualTitle: "عنوان التوصيل",
    locating: "جار تحديد الموقع…",
    gpsDenied: "لم تسمح بالوصول إلى موقعك.",
    gpsUnavailable: "تعذر العثور على موقعك حاليا.",
    gpsUnsupported: "تحديد الموقع غير متاح على هذا الجهاز.",
    outsideArea: "عذرا، نوصل فقط داخل مدينة {city}.",
    outsideAreaGps: "هذا الموقع خارج منطقة التوصيل ({city}).",
    deliveryAreaInfo: "منطقة التوصيل: {city}",
    makeDefault: "استخدامه كعنوان افتراضي",
    deleted: "تم حذف العنوان",
    saved: "تم حفظ العنوان",
    later: "لاحقا",
    addNowTitle: "أضف عنوان التوصيل",
    addNowText: "يمكنك إضافته الآن أو لاحقا عند الطلب.",
    gpsDialogTitle: "استخدام موقعك؟",
    gpsDialogText: "اسمح بتحديد الموقع لملء عنوان التوصيل تلقائيا. يمكنك أيضا إدخال عنوانك يدويا.",
    gpsEnable: "تفعيل",
    gpsNoThanks: "لا، شكرا",
    gpsSaving: "جار حفظ العنوان…",
    gpsFailedTitle: "تعذر تحديد موقعك",
    gpsTimeout: "استغرق تحديد الموقع وقتا طويلا.",
    gpsNotConfigured: "تحديد العنوان عبر GPS غير متاح حاليا.",
    gpsAddressSaved: "تم حفظ العنوان انطلاقا من موقعك",
    gpsDeniedHelp: "اسمح بتحديد الموقع لهذا الموقع في إعدادات المتصفح، ثم أعد المحاولة.",
    gpsInaccurate: "الموقع غير دقيق بما يكفي (± {distance}). فعّل تحديد الموقع الدقيق (GPS) في جهازك، ويفضل قرب نافذة أو في الخارج، ثم أعد المحاولة.",
    gpsInvalid: "الإحداثيات التي أرسلها جهازك غير صالحة.",
    gpsStale: "الموقع المستلم لم يكن محدثا. أعد المحاولة.",
    gpsInsecure: "لا يسمح متصفحك بتحديد الموقع إلا عبر اتصال آمن (HTTPS). هذه الصفحة مفتوحة عبر HTTP: أدخل عنوانك يدويا.",
    enterManually: "إدخال العنوان يدويا",
    gpsBased: "موقع GPS",
  },
  auth: {
    loginTitle: "تسجيل الدخول",
    loginSubtitle: "سجل الدخول برقم هاتفك.",
    phone: "رقم الهاتف",
    phonePlaceholder: "06 12 34 56 78",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    fullName: "الاسم الكامل",
    fullNamePlaceholder: "مثال: أمينة الإدريسي",
    login: "دخول",
    noAccount: "ليس لديك حساب؟",
    register: "إنشاء حساب",
    haveAccount: "لديك حساب؟",
    registerTitle: "إنشاء حساب",
    registerSubtitle: "سيتم إرسال رمز التحقق إليك عبر رسالة SMS.",
    registerSubtitleNoSms: "أنشئ حسابك في ثوان.",
    passwordHint: "8 أحرف على الأقل، مع حرف ورقم على الأقل.",
    forgot: "نسيت كلمة المرور؟",
    showPassword: "إظهار كلمة المرور",
    hidePassword: "إخفاء كلمة المرور",
    verifyTitle: "تأكيد رقم الهاتف",
    verifySubtitle: "أدخل الرمز المكون من 4 أرقام المرسل عبر SMS إلى",
    verify: "تحقق",
    resend: "إعادة إرسال الرمز",
    resendIn: "إعادة الإرسال بعد {s} ثانية",
    codeSent: "تم إرسال رمز جديد.",
    verified: "تم تأكيد رقمك! مرحبا بك.",
    changeNumber: "تغيير الرقم",
    forgotTitle: "نسيت كلمة المرور",
    forgotSubtitle: "أدخل رقمك. إذا كان مرتبطا بحساب، ستتلقى رمزا عبر SMS.",
    email: "البريد الإلكتروني",
    emailPlaceholder: "you@example.com",
    registerSubtitleEmail: "سيصلك رمز التحقق عبر البريد الإلكتروني.",
    verifyEmailTitle: "تأكيد البريد الإلكتروني",
    verifyEmailSubtitle: "أدخل الرمز المكون من 6 أرقام المرسل إلى",
    emailVerified: "تم تأكيد البريد الإلكتروني! مرحبا بك.",
    changeEmail: "تغيير البريد الإلكتروني",
    forgotSubtitleEmail: "أدخل البريد الإلكتروني لحسابك. إذا كان مرتبطا بحساب، ستتلقى رمزا عبر البريد الإلكتروني.",
    resetCodeSubtitleEmail: "إذا كان هذا البريد مرتبطا بحساب، فقد أرسلنا رمزا من 6 أرقام إلى",
    recoveryUnavailable:
      "نسيت كلمة المرور؟ تواصل معنا عبر واتساب وسنساعدك على استعادة الوصول إلى حسابك. إذا كان حسابك مرتبطا بـ Google، يمكنك أيضا تسجيل الدخول بواسطة Google.",
    contactWhatsApp: "تواصل معنا عبر واتساب",
    sendCode: "أرسل الرمز",
    resetCodeTitle: "رمز التحقق",
    resetCodeSubtitle: "إذا كان هذا الرقم مرتبطا بحساب، فقد تم إرسال رمز من 4 أرقام إلى",
    newPasswordTitle: "كلمة مرور جديدة",
    newPassword: "كلمة المرور الجديدة",
    resetDone: "تم تغيير كلمة المرور. سجل الدخول بكلمة المرور الجديدة.",
    savePassword: "حفظ كلمة المرور",
    loggedOut: "تم تسجيل الخروج.",
    welcomeBack: "مرحبا بعودتك، {name}!",
    otpLabel: "رمز التحقق",
    attemptsLeft: "المحاولات المتبقية: {n}.",
    loginRequired: "سجل الدخول للمتابعة.",
    continueWithGoogle: "المتابعة باستخدام Google",
    signUpWithGoogle: "التسجيل باستخدام Google",
    googleRedirecting: "جارٍ التوجيه إلى Google…",
    googleSignedIn: "تم تسجيل الدخول بواسطة Google.",
    googleWelcome: "مرحبا بك في طراوة! سيُطلب منك رقم هاتف موثق عند أول طلب.",
    googleLinked: "تم ربط حسابك على Google.",
  },
  errors: {
    generic: "حدث خطأ. حاول مرة أخرى.",
    network: "تعذر الاتصال. تحقق من اتصالك بالإنترنت.",
    VALIDATION_ERROR: "يرجى تصحيح الحقول المشار إليها.",
    INVALID: "قيمة غير صالحة.",
    TOO_LONG: "النص طويل جدا.",
    PHONE_REQUIRED: "أدخل رقم هاتفك.",
    PHONE_INVALID: "رقم مغربي غير صالح (مثال: 06 12 34 56 78).",
    NAME_REQUIRED: "أدخل اسمك الكامل.",
    NAME_TOO_SHORT: "أدخل اسمك الكامل.",
    NAME_TOO_LONG: "الاسم طويل جدا.",
    PASSWORD_REQUIRED: "أدخل كلمة المرور.",
    PASSWORD_TOO_SHORT: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
    PASSWORD_TOO_LONG: "كلمة المرور طويلة جدا.",
    PASSWORD_TOO_WEAK: "يجب أن تحتوي كلمة المرور على حرف ورقم على الأقل.",
    PASSWORDS_DO_NOT_MATCH: "كلمتا المرور غير متطابقتين.",
    PHONE_ALREADY_REGISTERED: "هذا الرقم مرتبط بحساب موجود. سجل الدخول.",
    PHONE_NOT_VERIFIED: "لم يتم تأكيد رقمك بعد. أدخل الرمز الذي وصلك عبر SMS.",
    INVALID_CREDENTIALS: "الرقم أو كلمة المرور غير صحيحة.",
    LOGIN_LOCKED: "محاولات كثيرة. حاول مجددا بعد بضع دقائق.",
    ACCOUNT_DISABLED: "هذا الحساب معطل. تواصل معنا.",
    OTP_REQUIRED: "أدخل الرمز الذي وصلك عبر SMS.",
    OTP_INVALID: "الرمز غير صحيح.",
    OTP_EXPIRED: "انتهت صلاحية هذا الرمز. اطلب رمزا جديدا.",
    OTP_TOO_MANY_ATTEMPTS: "محاولات كثيرة. اطلب رمزا جديدا.",
    OTP_RESEND_TOO_SOON: "انتظر قليلا قبل طلب رمز جديد.",
    OTP_TOO_MANY_REQUESTS: "طلبت رموزا كثيرة. حاول لاحقا.",
    SMS_SEND_FAILED: "فشل إرسال الرسالة. حاول بعد قليل.",
    REGISTRATION_EXPIRED: "انتهت صلاحية التسجيل. ابدأ من جديد.",
    RESET_TOKEN_INVALID: "لم يعد هذا الطلب صالحا. ابدأ من جديد.",
    PASSWORD_RECOVERY_UNAVAILABLE: "إعادة تعيين كلمة المرور غير متاحة مؤقتا. تواصل معنا.",
    EMAIL_REQUIRED: "أدخل بريدك الإلكتروني.",
    EMAIL_INVALID: "البريد الإلكتروني غير صالح.",
    EMAIL_ALREADY_REGISTERED: "هذا البريد الإلكتروني مرتبط بحساب. سجل الدخول.",
    EMAIL_NOT_VERIFIED: "لم يتم تأكيد بريدك الإلكتروني بعد. أدخل الرمز الذي وصلك عبر البريد الإلكتروني.",
    EMAIL_SEND_FAILED: "تعذر إرسال البريد الإلكتروني. حاول بعد قليل.",
    EMAIL_DAILY_LIMIT_REACHED: "خدمة إرسال البريد الإلكتروني مشغولة مؤقتا. حاول لاحقا.",
    REGISTRATION_CONFLICT: "هناك تسجيل جار بهذه المعلومات. حاول مرة أخرى.",
    RATE_LIMITED: "طلبات كثيرة. حاول بعد قليل.",
    UNAUTHENTICATED: "يرجى تسجيل الدخول.",
    OUTSIDE_DELIVERY_AREA: "العنوان خارج منطقة التوصيل.",
    ADDRESS_REQUIRED: "اختر عنوان التوصيل.",
    ADDRESS_TOO_SHORT: "العنوان قصير جدا، أضف تفاصيل.",
    ADDRESS_NOT_FOUND: "العنوان غير موجود.",
    CITY_REQUIRED: "أدخل المدينة.",
    GPS_INVALID: "موقع GPS غير صالح.",
    TOO_MANY_ADDRESSES: "لقد بلغت الحد الأقصى للعناوين.",
    PRODUCT_UNAVAILABLE: "هذا المنتج لم يعد متوفرا.",
    PACK_UNAVAILABLE: "هذه الباقة لم تعد متوفرة.",
    WEIGHT_INVALID: "هذا الوزن غير متوفر لهذا المنتج.",
    PRODUCTS_UNAVAILABLE: "بعض المنتجات لم تعد متوفرة. تم تحديث سلتك.",
    QUANTITY_TOO_HIGH: "تم بلوغ الكمية القصوى.",
    CART_EMPTY: "سلتك فارغة.",
    CART_FULL: "سلتك ممتلئة.",
    MIN_ORDER_NOT_MET: "لم يتم بلوغ الحد الأدنى للطلب.",
    DELIVERY_UNAVAILABLE: "التوصيل غير متاح حاليا.",
    ORDERING_CLOSED: "الطلبات مغلقة حاليا. نستقبل الطلبات من {start} إلى {end}.",
    COUPON_INVALID: "رمز التخفيض غير صالح.",
    COUPON_EXPIRED: "انتهت صلاحية رمز التخفيض.",
    COUPON_MIN_ORDER: "هذا الرمز صالح ابتداء من {amount}.",
    COUPON_USAGE_LIMIT_REACHED: "رمز التخفيض لم يعد متاحا.",
    PAYMENT_METHOD_INVALID: "الدفع عند الاستلام هو طريقة الدفع الوحيدة المقبولة.",
    ORDER_NOT_FOUND: "الطلب غير موجود.",
    GPS_AREA_NOT_CONFIGURED: "تحديد العنوان عبر GPS غير متاح حاليا. أدخل عنوانك يدويا.",
    NOT_FOUND: "غير موجود.",
    PHONE_UNCHANGED: "هذا هو رقمك الحالي بالفعل.",
    PHONE_CHANGE_CONFLICT: "تم تغيير رقمك في هذه الأثناء. أعد تحميل الصفحة وحاول مرة أخرى.",
    PHONE_VERIFICATION_REQUIRED: "أضف رقم هاتفك وتحقق منه قبل الطلب.",
    GOOGLE_AUTH_UNAVAILABLE: "تسجيل الدخول بواسطة Google غير متاح حاليا.",
    GOOGLE_CANCELLED: "تم إلغاء تسجيل الدخول بواسطة Google.",
    GOOGLE_STATE_INVALID: "تعذر التحقق من تسجيل الدخول بواسطة Google. حاول مرة أخرى.",
    GOOGLE_STATE_EXPIRED: "انتهت صلاحية تسجيل الدخول بواسطة Google. حاول مرة أخرى.",
    GOOGLE_FAILED: "فشل تسجيل الدخول بواسطة Google. حاول مرة أخرى.",
    GOOGLE_TOKEN_INVALID: "تعذر التحقق من استجابة Google. حاول مرة أخرى.",
    GOOGLE_EMAIL_NOT_VERIFIED: "البريد الإلكتروني لحساب Google هذا غير موثق.",
    GOOGLE_ACCOUNT_IN_USE: "حساب Google هذا مرتبط بالفعل بحساب آخر على طراوة.",
    GOOGLE_ALREADY_LINKED: "هذا الحساب مرتبط بحساب Google بالفعل.",
    GOOGLE_LINK_SESSION_INVALID: "تغيرت جلستك أثناء الربط. سجل الدخول من جديد وحاول مرة أخرى.",
  },
};
